// NPM Imports
import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

// Decalarations
const readerModes = [
  {
    id: "OFF",
    icon: ["far", "file-alt"],
    lineBreak: true,
  },
  {
    id: "ON",
    icon: ["far", "align-justify"],
    lineBreak: false,
  },
];

const RecipientDocReaderModeBtn = ({ readerMode, toggleReaderMode }) => (
  <div className="recipientdocreader-container">
    <Tooltip
      placement="left"
      overlay={` ${readerMode === "ON" ? "Reader mode on" : "Reader mode off"}`}
      align={{
        offset: [0, 4],
      }}>
      <div className="recipientdocreader-view-togglewrapper">
        {readerModes.map(mode => (
          <Fragment key={mode.id}>
            <div
              className={`recipientdocreader-view-icon ${
                readerMode === mode.id ? "active" : ""
              }`}
              role="button"
              tabIndex="0"
              onKeyPress={() => {}}
              onClick={() => toggleReaderMode(mode.id)}>
              <FontAwesomeIcon icon={mode.icon} />
            </div>
            {mode.lineBreak && <div className="line-break" />}
          </Fragment>
        ))}
      </div>
    </Tooltip>
  </div>
);

export default RecipientDocReaderModeBtn;
